import "./App.css";
import Navbar from "./components/Navbar/navbar";
import HomeSection from "./components/Home/HomeSection";
import ServicesSection from "./components/Services/services";
import AboutUsSection from "./components/About-us/about";
import ContactSection from "./components/Contact/contact";
import PlansSection from "./components/Plans/plans";
import FAQsSection from "./components/FAQs/faqs";
import FooterSection from "./components/Footer/footer";
import PerformanceSection from "./components/Performance/performance";
import StepsSection from "./components/Steps/steps";
import CarouselSection from "./components/Carousel/carousel";
import Cursor from "./components/cursor/Cursor";
function App() {
  return (
    <>
      <Cursor />
     

      <main className="main">
         <Navbar />
        <div className="section-container">
          <HomeSection />
        </div>
        <div className="section-container">
          <CarouselSection />
        </div>
        <div className="section-container">
          <ServicesSection />
        </div>
        <div className="section-container-steps">
          <AboutUsSection />
        </div>
        <div className="section-container" style={{ height: '45vh' }}>
          <PerformanceSection />
        </div>
        <div className="section-container-steps">
          <StepsSection />
        </div>
        <div className="section-container">
          <PlansSection />
        </div>
        <div className="section-container">
          <FAQsSection />
        </div>

        <ContactSection />

      </main>

      <FooterSection />
    </>
  );
}

export default App;
